module.exports = __webpack_public_path__ + "static/media/magnifying-glass.bc712f85.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svg/magnifying-glass.svg
// module id = Ctet
// module chunks = 89